import React, { useCallback, useContext } from 'react';
import { convertFromPopperPlacement } from '@wix/da-ds/pkg/popper/helpers';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import { setRefs } from '../../utils/refHelpers';
import { DropdownStateContext } from '../DropdownStateManager';
import { PopperDropdownContext } from './PopperDropdownContext';
const PopperDropdownContent = /*#__PURE__*/ React.forwardRef(({ usePortal, placement: popperPlacement = 'bottom-end', offsetModifier, allowFlip, children, role, className, popperClassName, referenceElement, 'aria-label': ariaLabel }, ref)=>{
    const { isOpen, setMenuRef, closeDropdown } = useContext(DropdownStateContext);
    const { toggleElement } = useContext(PopperDropdownContext);
    const { placement, secondaryPlacement } = convertFromPopperPlacement(popperPlacement);
    const onKeyDown = useCallback((e)=>{
        switch(e.key){
            case 'Escape':
                closeDropdown();
                break;
            default:
                break;
        }
    }, [
        closeDropdown
    ]);
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        isVisible: isOpen,
        usePortal: usePortal,
        referenceElement: referenceElement !== null && referenceElement !== void 0 ? referenceElement : toggleElement,
        popoverContent: children,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        offsetModifier: offsetModifier,
        allowFlip: allowFlip,
        innerRef: (node)=>setRefs([
                setMenuRef,
                ref
            ], node),
        className: className,
        wrapperClassName: popperClassName,
        onKeyDown: onKeyDown,
        role: role,
        "aria-label": ariaLabel
    });
});
PopperDropdownContent.displayName = 'PopperDropdownContent';
export default PopperDropdownContent;
